import { Button } from '@material-ui/core';
import { Fullscreen, FullscreenExit } from '@material-ui/icons';
import { isNotNullNorUndefined } from 'helpers/ts-helpers';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';

import styles from './FullScreen.module.scss';

type Props = {
  isOnlyIcon: boolean;
};

const FullScreen = ({ isOnlyIcon }: Props) => {
  const intl = useIntl();
  const isFullScreenOn = isNotNullNorUndefined(document.fullscreenElement) ? true : false;
  const [isFullScreenMode, setIsFullScreenMode] = useState<boolean>(isFullScreenOn);

  const fullscreenEddr = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => {
        toast.error(intl.formatMessage({ id: 'eddr.operationsLogs.errorFullScreen' }));
      });
    } else {
      document.documentElement.requestFullscreen().catch(() => {
        toast.error(intl.formatMessage({ id: 'eddr.operationsLogs.errorFullScreen' }));
      });
    }
  };

  useEffect(() => {
    window.addEventListener('fullscreenchange', () => {
      if (document.fullscreenElement) {
        setIsFullScreenMode(true);
      } else {
        setIsFullScreenMode(false);
      }
    });
  }, []);

  return (
    /* eslint-disable-next-line react/no-unknown-property */
    <div onClick={fullscreenEddr} joyride-id="eddr-overview-full-screen-button">
      {isOnlyIcon && (
        <div className={styles.circleWrapped}>
          {isFullScreenMode ? <FullscreenExit /> : <Fullscreen />}
        </div>
      )}
      {!isOnlyIcon && (
        <Button className={styles.zoomContainer}>
          {isFullScreenMode ? <FullscreenExit /> : <Fullscreen />}
        </Button>
      )}
    </div>
  );
};

export default FullScreen;
